export default __webpack_public_path__ + "static/media/bulgarian_cheese.26d37897.png";